import axios from 'axios';
import { ADMIN_PANEL_BACKEND_BASE_URL, AFFILIATE_PANEL_BACKEND_INSTANCE } from '../utils/Constants';

const AffiliatePanelInstance = axios.create({
    baseURL: ADMIN_PANEL_BACKEND_BASE_URL
});

export default AffiliatePanelInstance;